import { render, staticRenderFns } from "./ButtonShare.vue?vue&type=template&id=5a0a4d2d&scoped=true&"
import script from "./ButtonShare.vue?vue&type=script&lang=js&"
export * from "./ButtonShare.vue?vue&type=script&lang=js&"
import style0 from "./ButtonShare.vue?vue&type=style&index=0&id=5a0a4d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a4d2d",
  null
  
)

export default component.exports